var BlockView = require('views/block/base-block-view');

let DividerView = BlockView.extend({
  initialize: function() {
    this.model.set('cid', this.model.cid);
    BlockView.prototype.initialize.apply(this, arguments);
  },
  load: function() {
  },
  play: function() {
    this.readyToGo();
  }  
});

export default DividerView;